<template>
    <card class="card">
    {{ form.assessment }}

        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-file-alt text-primary"></i> Responder Questionário
            </h2>
            <hr />
            <div class="row">
                <div class="col-md-12">
                  <h4 class="mt-0">{{ form.assessment.title }}</h4>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-12">
                  {{ form.assessment.description }}
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                  <h5>Data de início:</h5>
                  {{ form.assessment.start_date | moment("DD/MM/YYYY") }}
                </div>
                <div class="col-md-6">
                  <h5>Data de encerramento:</h5>
                  {{ form.assessment.end_date | moment("DD/MM/YYYY") }}
                </div>
            </div>
            <hr />
            <div class="row mt-5">
              <div class="col-md-12">
                <h3 class="pt-0 mt-0">
                    <i class="fas fa-question text-primary"></i> Questões
                  </h3>
              </div>
            </div>
            <!-- Perguntas -->
            <AssessmentQuestion v-model="form.assessment.questions" :immediateWatch="true" />
            
            <div class="text-left">
                <p-button type="primary" @click.native.prevent="save">Responder</p-button>
            </div>
            <div class="clearfix"></div>
        </div>
    </card>
</template>
<script>
import Multiselect from "vue-multiselect";
import deepmerge from "deepmerge";
import { mapState } from "vuex";
import AssessmentQuestion from "./components/AssessmentQuestion";

export default {
  components: {
    AssessmentQuestion
  },
  data() {
    return {
      form: {
        asf_id: this.$store.getters["auth/getCurrentAsf"],
        assessment: {
          id: "",
          title: "",
          description: "",
          start_date: "",
          end_date: "",
          questions: []
        }
      }
    };
  },
  computed: {
    ...mapState("assessments", {
      assessment: "assessment"
    })
  },
  watch: {
    assessment: function(newData) {
      this.form.assessment = deepmerge(this.form.assessment, newData, {
        arrayMerge: (destination, source) => {
          return [...destination, ...source];
        }
      });
    }
  },
  created() {
    this.$store
      .dispatch("assessments/get", this.$route.params.id)
      .catch(error => {
        let msg = "";
        if (error.response.data) {
          msg = error.response.data.errors[0].detail;
        } else {
          msg = error.response.message;
        }
        this.$notify({
          type: "danger",
          horizontalAlign: "center",
          message: msg
        });
      });
  },
  methods: {
    save() {
      this.$store
        .dispatch("assessments/answer", this.form)
        .then(response => {
          this.$router.push({ name: "assessment" });
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: "Assessment sent with success!"
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
